export const FIELD_REPLACEMENT_SETS = {
  email: 'email',
  packingSlip: 'packing-slip',
  packingSlipOrderItems: 'packing-slip-order-items',
};
